import { AnimationFactory } from "./AnimationFactory";
export const Fade = AnimationFactory({
    initial: {
        opacity: 0,
    },
    animate: {
        opacity: 1,
        transition: {
            duration: 250,
        },
    },
})